import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const FaucetIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#00598E"
      strokeWidth="3"
      {...props}
      htmlColor="transparent"
    >
      <path
        d="M36.6689 16.6672V29.4672M26.6689 16.6672H46.6689"

        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 30V56.6672M56.6672 36.6672H48.7328C48.1114 36.6721 47.5011 36.503 46.9709 36.1789C46.4407 35.8549 46.0118 35.3888 45.7328 34.8336L44.2672 31.8336C43.9882 31.2784 43.5593 30.8124 43.0291 30.4883C42.4989 30.1642 41.8886 29.9951 41.2672 30H32.0672C31.4458 29.9951 30.8355 30.1642 30.3053 30.4883C29.7751 30.8124 29.3462 31.2784 29.0672 31.8336L27.6 34.8336C27.321 35.3888 26.8921 35.8549 26.3619 36.1789C25.8317 36.503 25.2214 36.6721 24.6 36.6672H10V50H53.3328C53.7706 49.9998 54.2042 50.0859 54.6087 50.2532C55.0132 50.4206 55.3808 50.6661 55.6905 50.9756C56.0001 51.2851 56.2458 51.6526 56.4134 52.057C56.5809 52.4615 56.6672 52.895 56.6672 53.3328V60C56.6672 60.8839 57.0183 61.7316 57.6434 62.3567C58.2684 62.9817 59.1161 63.3328 60 63.3328H66.6672C67.5511 63.3328 68.3988 62.9817 69.0238 62.3567C69.6489 61.7316 70 60.8839 70 60V50C70 46.4639 68.5953 43.0727 66.0949 40.5723C63.5945 38.0719 60.2033 36.6672 56.6672 36.6672Z"

        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
